type AuthFlow = 'signIn' | 'forgotPassword' | 'forgotPasswordSubmit' | 'signUp' | 'completeNewPassword'

export const sanitizeAuthError = (error: { code?: string }, flow: AuthFlow): string => {
  const code = error?.code || ''

  if (flow === 'signIn') {
    if (['UserNotFoundException', 'NotAuthorizedException', 'UserNotConfirmedException'].includes(code)) {
      return 'Invalid email or password.'
    }
  }

  if (flow === 'forgotPassword') {
    if (['NotAuthorizedException', 'UserNotFoundException'].includes(code)) {
      return 'If the email address is registered, a verification code has been sent.'
    }
  }

  const commonMessages: Record<string, string> = {
    CodeMismatchException: 'The verification code is invalid.',
    ExpiredCodeException: 'The verification code has expired. Please request a new one.',
    InvalidPasswordException: 'Password does not meet the requirements.',
    LimitExceededException: 'Too many attempts. Please try again later.',
    InvalidParameterException: 'Invalid input. Please check your entries.',
  }

  return commonMessages[code] || 'An error occurred. Please try again.'
}
